import {Component, EventEmitter, Input, Output} from '@angular/core';
import {League} from "@model";
import {max_length_255, required} from "@utility";
import {AbstractComponent} from "../../abstract.component";
import {TranslocoService} from "@ngneat/transloco";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormControl, FormGroup} from "@angular/forms";


@Component({
  selector: 'app-copy-league-modal',
  templateUrl: './copy-league-modal.component.html',
  styleUrl: './copy-league-modal.component.scss',
  standalone: false,
})
export class CopyLeagueModalComponent extends AbstractComponent{
  @Input() league: League | undefined;
  @Output() onSave: EventEmitter<League> = new EventEmitter<League>();

  constructor(public translocoService: TranslocoService,
              public activeModal: NgbActiveModal) {
    super();
  }

  inputForm = new FormGroup({
    name: new FormControl(),
    nameEng: new FormControl(),
    nameIta: new FormControl(),
    nameSlo: new FormControl(),
    nameSr: new FormControl(),
    nameBs: new FormControl(),
    start: new FormControl(),
    end: new FormControl(),
  });

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.inputForm.controls.name.addValidators([required, max_length_255]);
    this.inputForm.controls.nameEng.addValidators([max_length_255]);
    this.inputForm.controls.nameIta.addValidators([max_length_255]);
    this.inputForm.controls.nameSlo.addValidators([max_length_255]);
    this.inputForm.controls.nameSr.addValidators([max_length_255]);
    this.inputForm.controls.nameBs.addValidators([max_length_255]);
    this.inputForm.controls.start.addValidators([required]);
    this.inputForm.controls.end.addValidators([required]);
    if (this.league) {
      this.inputForm.patchValue(this.league);
    }
  }

  onClose(): void {
    this.activeModal.dismiss();
  }

  onSaveButtonClick(): void {
    if (!this.inputForm.valid) {
      this.markAllAsTouched(this.inputForm);
    }
    else {
      let copyLeague: League = {...this.league}
      copyLeague.id = undefined;
      copyLeague.name = this.inputForm.value.name;
      copyLeague.nameEng = this.inputForm.value.nameEng;
      copyLeague.nameIta = this.inputForm.value.nameIta;
      copyLeague.nameSlo = this.inputForm.value.nameSlo;
      copyLeague.nameSr = this.inputForm.value.nameSr;
      copyLeague.nameBs = this.inputForm.value.nameBs;
      copyLeague.start = this.inputForm.value.start;
      copyLeague.end = this.inputForm.value.end;
      this.onSave.emit(copyLeague);
    }
  }
}
